<template>
  <div class="title-comp" :class="{'write-color' : color === 'write'}">
    <h2 class="cn">{{titleCn}}</h2>
    <!-- 彩色条带 -->
    <ul class="color-bar">
      <li></li>
      <li></li>
      <li></li>
      <li></li>
    </ul>
    <p class="en">{{titleEn}}</p>
  </div>
</template>

<script>
  export default {
    name: "TitleComp",
    props: {
      titleCn: String,
      titleEn: String,
      color: {
        type: String,
        default: 'black'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .title-comp {
    text-align: center;
    position: relative;
    width: 100%;
    .cn {
      font-family: inherit;
      font-weight: bold;
      font-size: 60px;
      color: #2e3233;
    }
    .en {
      font-weight: bold;
      font-size: 34px;
      color: #333;

      position: relative;
      z-index: 2;
    }
  }

  // 彩色条带
  .color-bar {
    width: 360px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    bottom: 31px;
    li {
      height: 5px;
      width: 90px;
      float: left;
      background: #e00068;
      position: relative;
      opacity: 0.7;
      &:nth-child(2) {
        background: #ffdd06;
      }
      &:nth-child(3) {
        background: #86b719;
      }
      &:nth-child(4) {
        background: #00a2e8;
      }
    }
  }

  .write-color {
    .cn, .en {
      color: #ffffff;
    }
  }
</style>